export default {
	id: 'SIMPLE_UPGRADE_9M_79_95',
	providers: {
		stripe: '',
		braintree: '',
		paltaMap: {
			USD: 'simple_premium_9m_79_95_usd',
			EUR: 'simple_premium_9m_79_95_eur',
			GBP: 'simple_premium_9m_79_95_gbp',
			AUD: 'simple_premium_9m_119_aud',
			CAD: 'simple_premium_9m_119_cad',
			SEK: 'simple_premium_9m_939_sek',
			BRL: 'simple_premium_9m_239_20_brl',
			DKK: 'simple_premium_9m_589_dkk',
			NOK: 'simple_premium_9m_939_nok',
			MXN: 'simple_premium_9m_1319_mxn',
			TRY: 'simple_premium_9m_2699_try',
			ARS: 'simple_premium_9m_106590_ars',
			COP: 'simple_premium_9m_324490_cop',
			CLP: 'simple_premium_9m_77590_clp',
		},
		primer: 'prd_ev05zQ6guNlc',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 9,
		intro_period_type: 'month',
		next_period_value: 9,
		next_period_type: 'month',
	},
	trial: null,
	subscription: {
		interval: 'month',
		intervalCount: 9,
		priceMap: {
			USD: 79.95,
			EUR: 79.95,
			GBP: 79.95,
			AUD: 119,
			CAD: 119,
			SEK: 939,
			BRL: 239.2,
			DKK: 589,
			NOK: 939,
			MXN: 1319,
			TRY: 2699,
			ARS: 106590,
			COP: 324490,
			CLP: 77590,
		},
	},
	options: ($t) => ({
		barChartTooltip: $t('activity_upgrade.9mo.bar_chart_tooltip'),
		barChartLeftLabel: $t('activity_upgrade.9mo.bar_chart_left_label'),
		barChartRightLabel: $t('activity_upgrade.9mo.bar_chart_right_label'),
	}),
}
